import { Component, computed, inject, input, OnInit } from "@angular/core";
import { StockTypeFormComponent } from "../../components/stock-type-form/stock-type-form.component";
import { updateStockTypeConfig } from "../../configs/update-stock-type.config";
import { PageHeaderComponent } from "@app/shared-core/components/page-header/page-header.component";
import { SxwFormComponent } from "@app/kernel/form/components/sxw-form/sxw-form.component";
import { Router } from "@angular/router";
import { StockTypeForm } from "../../models/stock-type-form.model";
import { updateBreadCrumb } from "@app/applications/stock/domains/stock-type/configs/bread-crumb-stock-type.config";
import { BreadCrumbComponent } from "@kernel/tools/bread-crumb/components/bread-crumb/bread-crumb.component";
import { IStockType } from "@app/shared/settings/stock-type/interfaces/stock-type.interface";
import { StockTypeRoutePaths } from "@app/applications/stock/domains/stock-type/stock-type-route-paths";
import { PageTitleService } from "@app/shared/general/services";

@Component({
  selector: "app-update-stock-type",
  imports: [StockTypeFormComponent, PageHeaderComponent, SxwFormComponent, BreadCrumbComponent],
  templateUrl: "./update-stock-type.component.html",
  styleUrl: "./update-stock-type.component.scss",
  providers: [StockTypeForm],
})
export class UpdateStockTypeComponent implements OnInit {
  /**
   * Injecting the Angular Router for navigation
   * @private
   */
  private router = inject(Router);

  /**
   * Page title service for clean title management
   */
  pageTitle = inject(PageTitleService);

  /**
   * Injecting the StockTypeForm model for managing form state
   */
  public readonly formModel = inject(StockTypeForm);

  /**
   * Come from resolver as input
   */
  stockType = input.required<IStockType>();

  stockTypeName = computed(() => this.stockType()?.name ?? "");

  /**
   * Configuration for the mutation operation
   */
  mutationConfigType = updateStockTypeConfig();

  protected readonly breadCrumb = updateBreadCrumb(this.stockType);

  /**
   * Angular lifecycle hook to initialize the form with customerType data.
   */
  ngOnInit() {
    this.formModel.setEntity(this.stockType());
    this.pageTitle.setupDynamicTitle("STOCK_TYPE.TITLES.EDIT", this.stockTypeName);
  }

  /**
   * Method to navigate back to the stock type list page
   */
  navigateToList() {
    return this.router.navigate([StockTypeRoutePaths.ROOT]);
  }

  protected readonly StockTypeRoutePaths = StockTypeRoutePaths;
}
